import type { ScreenviewNode } from '../types';
import { toNumber, toString } from './parse-helpers';

/**
 * Parse screenview conditions.
 * Handles: { event: { type: 'screen', name }, times, within, inverse }
 *          { type: 'screenview', screen, times, within, inverse }
 */
export function parseScreenview(raw: Record<string, unknown>): ScreenviewNode | null {
  // oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
  const event = raw.event as Record<string, unknown> | undefined;
  if (event?.type === 'screen' || event?.type === 'screenview') {
    const name = toString(event.name);
    // oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
    const eventFilter = raw.event_filter as Record<string, unknown> | undefined;
    return {
      type: 'screenview',
      screen: name !== '*' ? name : undefined,
      inverse: (eventFilter?.inverse ?? raw.inverse) === true,
      times: toNumber(eventFilter?.times ?? raw.times),
      within: toNumber(eventFilter?.within ?? raw.within),
    };
  }

  if (raw.type === 'screenview') {
    const name = toString(raw.screen ?? raw.name);
    return {
      type: 'screenview',
      screen: name !== '*' ? name : undefined,
      inverse: raw.inverse === true,
      times: toNumber(raw.times),
      within: toNumber(raw.within),
    };
  }

  return null;
}
